import { AfterViewInit, DestroyRef, Directive, ElementRef, HostListener, inject, input, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, fromEvent } from 'rxjs';

@Directive({
  selector: '[appTruncateTooltip]',
  standalone: true,
  hostDirectives: [
    {
      directive: MatTooltip,
      inputs: ['matTooltipShowDelay'],
    },
  ],
})
export class TruncateTooltipDirective implements OnInit, AfterViewInit {
  readonly appTruncateTooltip = input.required<string>();
  readonly truncateCheckSelector = input<string>();

  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly tooltip = inject(MatTooltip);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.tooltip.message = this.appTruncateTooltip();
    this.tooltip.disabled = true;
  }

  ngAfterViewInit(): void {
    this.checkTruncation();

    fromEvent(window, 'resize')
      .pipe(debounceTime(100), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.checkTruncation());
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.checkTruncation();
  }

  private checkTruncation(): void {
    const selector = this.truncateCheckSelector();
    const element = selector ? this.elementRef.nativeElement.querySelector(selector) : this.elementRef.nativeElement;

    if (!element) {
      this.tooltip.disabled = true;
      return;
    }

    const isTruncated = element.scrollWidth > element.clientWidth;
    this.tooltip.message = this.appTruncateTooltip();
    this.tooltip.disabled = !isTruncated;
  }
}
